var AddPatientEntityType;
(function (AddPatientEntityType) {
    AddPatientEntityType["PATIENT"] = "patient";
    AddPatientEntityType["CONTACT"] = "contact";
})(AddPatientEntityType || (AddPatientEntityType = {}));

export { AddPatientEntityType };
